export const OKTA_CONFIG = {
  client_id: "0oa5exqdx7d7d0AKz0i7",
  redirect_uri: `${window.location.origin}/login/callback`,
  authorization_endpoint: "https://ecos.okta-emea.com/oauth2/default/v1/authorize",
  token_endpoint: "https://ecos.okta-emea.com/oauth2/default/v1/token",
  requested_scopes: "openid profile email",
};

export const FUNCTION_KEY = "ikNk5EVnJzLaa0uhnlfH7a44GbodKgGOZ2TgjgWyRiNQtUl63W1c3A==";

// Permissions required
// table - object - read, list
